import { render } from "./StatisticsItemView.vue?vue&type=template&id=b4eb7bde&scoped=true"
import script from "./StatisticsItemView.vue?vue&type=script&lang=js"
export * from "./StatisticsItemView.vue?vue&type=script&lang=js"

import "./StatisticsItemView.vue?vue&type=style&index=0&id=b4eb7bde&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4eb7bde"]])

export default __exports__